import { render, staticRenderFns } from "./KeyWordSearch.vue?vue&type=template&id=507f4c9b&"
import script from "./KeyWordSearch.vue?vue&type=script&lang=js&"
export * from "./KeyWordSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports